import {iconUrl} from 'data/icon'
import {ensureStatuses} from '../type'

export const MNK = ensureStatuses({
	OPO_OPO_FORM: {
		id: 107,
		name: 'Opo-Opo Form',
		icon: iconUrl(210212),
		duration: 30000,
	},

	RAPTOR_FORM: {
		id: 108,
		name: 'Raptor Form',
		icon: iconUrl(210213),
		duration: 30000,
	},

	COEURL_FORM: {
		id: 109,
		name: 'Coeurl Form',
		icon: iconUrl(210214),
		duration: 30000,
	},

	MANTRA: {
		id: 102,
		name: 'Mantra',
		icon: iconUrl(210206),
		duration: 15000,
	},

	PERFECT_BALANCE: {
		id: 110,
		name: 'Perfect Balance',
		icon: iconUrl(210217),
		duration: 30000,
		stacksApplied: 3,
	},

	BROTHERHOOD: {
		id: 1185,
		name: 'Brotherhood',
		icon: iconUrl(212532),
		duration: 20000,
	},

	MEDITATIVE_BROTHERHOOD: {
		id: 1182,
		name: 'Meditative Brotherhood',
		icon: iconUrl(212529),
		duration: 20000,
	},

	RIDDLE_OF_EARTH: {
		id: 1179,
		name: 'Riddle of Earth',
		icon: iconUrl(212527),
		duration: 10000,
	},

	EARTHS_REPLY: {
		id: 1180,
		name: "Earth's Reply",
		icon: iconUrl(212531),
		duration: 15000,
	},

	EARTHS_RUMINATION: {
		id: 3841,
		name: "Earth's Rumination",
		icon: iconUrl(212539),
		duration: 30000,
	},

	RIDDLE_OF_FIRE: {
		id: 1181,
		name: 'Riddle of Fire',
		icon: iconUrl(212528),
		duration: 20000,
	},

	FIRES_RUMINATION: {
		id: 3843,
		name: "Fire's Rumination",
		icon: iconUrl(212541),
		duration: 20000,
	},

	RIDDLE_OF_WIND: {
		id: 2687,
		name: 'Riddle of Wind',
		icon: iconUrl(212537),
		duration: 15000,
	},

	WINDS_RUMINATION: {
		id: 3842,
		name: "Wind's Rumination",
		icon: iconUrl(212540),
		duration: 15000,
	},

	FORMLESS_FIST: {
		id: 2513,
		name: 'Formless Fist',
		icon: iconUrl(212535),
		duration: 30000,
	},

	SIX_SIDED_STAR: {
		id: 2514,
		name: 'Six-sided Star',
		icon: iconUrl(212536),
		duration: 5000,
	},
})
